import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatFormField, MatPrefix, MatInput } from '@angular/material/input';
import { MatIconButton } from '@angular/material/button';
import { Angulartics2OnModule } from 'angulartics2';
import { MatIcon } from '@angular/material/icon';
import { MatBadge } from '@angular/material/badge';

@Component({
    selector: 'search-input',
    templateUrl: './search-input.component.html',
    styleUrls: ['./search-input.component.scss'],
    imports: [ReactiveFormsModule, MatFormField, MatIconButton, MatPrefix, Angulartics2OnModule, MatIcon, MatInput, MatBadge]
})
export class SearchInputComponent {

  searchForm = new FormGroup({
    q: new FormControl('', [Validators.maxLength(1000)]),
  });
  
  currentCategory: string | undefined;
  @Output() onFiltersClicked: EventEmitter<void> = new EventEmitter();
  numberOfAppliedFilters: number = 0;

  constructor(
    private router: Router,
    activatedRoute: ActivatedRoute) {
    
    activatedRoute.queryParams.subscribe(queryParams => {
      
      this.currentCategory = queryParams["categoryCode"];
      
      if (queryParams["categoryCode"]) {
        this.numberOfAppliedFilters = 1;
      } else {
        this.numberOfAppliedFilters = 0;
      }
      
      if (queryParams["q"]) {
        this.searchForm.controls["q"].setValue(queryParams["q"]); 
      } else {
        this.searchForm.controls["q"].reset();
      }
    })
  }
  
  get showFilterButton(): boolean {
    return this.numberOfAppliedFilters > 0;
  }
  
  search() {
    
    if (this.searchForm.invalid) {
      console.log("Invalid");
      return;
    }
    
    const params: any = {
      q: this.searchForm.controls["q"].value
    }
    
    if (this.currentCategory) {
      params["categoryCode"] = this.currentCategory;
    }
    
    this.router.navigate(["/marketplace"], { queryParams: params });
  }
  
  triggerOnFiltersClicked() {
    this.onFiltersClicked.emit();    
  }
}
